import React from 'react'
import PropTypes from 'prop-types'
import intl from 'react-intl-universal'
import { SVGIcon } from 'components/qstrap'

const Title = ({ className }) => (
  <div className={`text-center instructions-title ${className}`}>
    <b className="m-r-sm">
      {intl.get('aptitude.questions.bar.title')}
    </b>
    <SVGIcon name="ask_question" className="text-success" />
  </div>
)

Title.propTypes = {
  className: PropTypes.string,
}

export default Title
